import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const setArchivedOrganization = createAsyncThunk(
  'organizations/setArchivedOrganization',
  async ({ orgId, isArchived, archiveValue }, { rejectWithValue }) => {
    try {
      // TODO: add api call when backend is ready
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      return {
        orgId,
        isArchived,
        archiveValue,
      };
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const setArchivedOrganizationExtraReducers = builder => {
  builder
    .addCase(setArchivedOrganization.pending, (state, action) => {
      const { orgId } = action.meta.arg;
      checkAndSetLoadingWithId(
        state.organizations.organization.actions.archive.request,
        action,
        orgId,
      );
    })
    .addCase(setArchivedOrganization.fulfilled, (state, action) => {
      const { orgId } = action.meta.arg;
      onMatchedRequest(
        state.organizations.organization.actions.archive.request[orgId],
        action,
        () => {
          // TODO: set value when backend is ready
        },
      );
    })
    .addCase(setArchivedOrganization.rejected, (state, action) => {
      const { orgId } = action.meta.arg;
      handleRequestRejection(
        state.organizations.organization.actions.archive.request[orgId],
        action,
      );
    });
};
